const getDefaultState = () => {
  return {
    show: false,
    relogin: false
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_SHOW: (state, show) => {
    state.show = show;
  },
  SET_RELOGIN: (state, bool) => {
    state.relogin = bool;
  },
  RESET: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  //show snackbar
  show({ commit }) {
    commit("SET_SHOW", true);
    document.documentElement.style.overflow = "hidden";
    document.body.scroll = "no";
  },
  relogin({ commit }, bool) {
    commit("SET_RELOGIN", bool);
  },
  close({ commit }) {
    localStorage.removeItem("toPath");
    document.documentElement.style.overflow = "scroll";
    document.body.scroll = "yes";

    commit("SET_SHOW", false);
    setTimeout(() => {
      commit("RESET");
    }, 300);
  }
};

const getters = {
  showLogin: state => state.show,
  relogin: state => state.relogin
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
